const contractLinkedContractsActions = {
  CONTRACT_LINKED_CONTRACTS_INIT: 'CONTRACT_LINKED_CONTRACTS_INIT',
  CONTRACT_LINKED_CONTRACTS_SET: 'CONTRACT_LINKED_CONTRACTS_SET'
};

export default contractLinkedContractsActions;